<template>
<span>
<p><span style="font-size:10pt">Inhalt der Leistung:</span></p>

<ul>
  <li>
    <p><span style="font-size:10pt">Schutzraum&uuml;berpr&uuml;fung von bestehenden Blitzschutzanlagen nach einer gew&auml;hlten Blitzschutzklasse</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Die &Uuml;berpr&uuml;fung erfolgt in 3D</span></p>
  </li>
</ul>

<p><span style="font-size:9pt"><em>Hinweis: Also Grundlage wird ein 3d-Modell mit bestehenden Fangeinrichtungen ben&ouml;tigt.<br />
Dieses Modell kann uns vom Kunden zur Verf&uuml;gung gestellt werden.</em></span></p>

<p><span style="font-size:9pt"><em>Optional: Ein Modell kann von uns &uuml;ber die Leistung &bdquo;Zeichnungserstellung&ldquo; oder &bdquo;Laserscanning&ldquo; erstellt werden</em></span></p>

</span>
</template>

<script>
export default {
  name: "TooltipSchutzraum"
}
</script>

<style scoped>

</style>
